import createSummaryTrans from "./create_summary_trans";

export const insertAccountTotalAndBalanceFwd = (summaryTranArr, savingsClass, gameYear) => {
    let totalTranArr = [];
    let totalTranAmt = 0;
    let totalShareQuantity = 0;
    let prevTranYear = "";
    let prevSavingsType = "";
    let prevTranObj = {};
    let createBalanceFwd = false;
    let tranNbr = 0;
    for (let i=0; i<summaryTranArr.length; i++){
        if (summaryTranArr[i].tranYear !== prevTranYear ||
            summaryTranArr[i].savingsType !== prevSavingsType){
            if (prevTranYear !== ""){
                if (prevTranYear < gameYear){
                    createBalanceFwd = true;
                }else{
                    createBalanceFwd = false;
                }
                const newTotalTranArr = createSummaryTrans(savingsClass, prevTranObj, prevTranYear, totalTranAmt, 
                   totalShareQuantity, createBalanceFwd);
                totalTranArr = totalTranArr.concat(newTotalTranArr);
                if (summaryTranArr[i].savingsType !== prevSavingsType){
                    totalTranAmt = 0;
                    tranNbr = 0;
                }else{
                    tranNbr += 2;
                }
            }
            prevTranYear = summaryTranArr[i].tranYear;
            prevSavingsType = summaryTranArr[i].savingsType;
        }
        tranNbr += 1;
        summaryTranArr[i] = {...summaryTranArr[i], tranNbr: tranNbr};
        totalTranArr.push(summaryTranArr[i]);
        prevTranObj = summaryTranArr[i];
        totalTranAmt += summaryTranArr[i].tranAmt;
        if (savingsClass === "retirement"){
            totalShareQuantity += +summaryTranArr[i].shareQuantity;
        }
    }
    createBalanceFwd = false;
    const newTotalTranArr = createSummaryTrans(savingsClass, prevTranObj, prevTranYear, totalTranAmt, 
        totalShareQuantity, createBalanceFwd);
    totalTranArr = totalTranArr.concat(newTotalTranArr); 
    return totalTranArr;
}
export default insertAccountTotalAndBalanceFwd;